import React from 'react';

const ImSection = (props) => {
    const content = props.content || {};
    return (
        <section id="im" className=" w-full bg-pf-bglight relative flex flex-col items-center justify-center py-6">
            <div className="wrapper p-6 md:p-0 flex flex-row justify-center items-center w-full">
                <div className='w-full bg-pf-bgDarker rounded-2xl shadow-lg border border-[#eaeaea] overflow-hidden flex flex-col-reverse md:flex-row justify-center items-center'>
                    <div className="im-section-content px-2 py-2 md:py-6 md:px-16">
                        <div className="text-pf-titleDark text-center text-subtitle-sm md:text-left md:text-subtitle md:px-16 md:py-6 px-6 pb-6">
                            {content.im.title}
                        </div>
                        <p className="text-pf-titleDark md:px-16 px-6 pb-6" dangerouslySetInnerHTML={{ __html: content.im.subtitle }} />
                    </div>
                    <div className='md:w-1/2 w-10/12 p-10 md:p-16 md:p-0">'>
                        <img src={content.im.imageUrl} alt="im icons" className="w-10/12 md:w-8/12 mx-auto rounded-2xl shadow-black/10 shadow-lg" />
                    </div>
                </div>

            </div>
        </section>
    );
};

export default ImSection;